<div class="dialog-wrapper">
  <h2 mat-dialog-title>{{ 'requestDefinitions.dialog.dialogTitle' | translate }}</h2>
  <div mat-dialog-content class="mat-typography">
    <p *ngIf="data.description">
      {{ data.description }}
    </p>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-button (click)="closeDialog()">{{ 'requestDefinitions.dialog.closeDialog' | translate }}</button>
  </div>
</div>
